<nav class="navbar navbar-expand-lg navbar-light container">
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#main_nav" aria-controls="main_nav" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <!-- Mobile Logo -->
  <div class="logo d-lg-none">
    <a class="navbar-brand" style="width:100px;height:82px;position:relative;margin-right:0;" [routerLink]="['/flightSearch']">
      <img class="logo-img" [src]="logo" alt="ok-travels" />
    </a>
  </div>
  <div class="collapse navbar-collapse d-lg-flex justify-content-between" id="main_nav">
    <!-- Desktop Logo -->
    <div class="logo d-none d-lg-block">

      <a class="navbar-brand" style="width:100px;height:82px;position:relative" [routerLink]="['/flightSearch']">

        <img class="logo-img" [src]="logo" alt="ok-travels" />

        <!--<img class="logo-img" src="assets/img/OKlogo.png" alt="" />-->

      </a>

    </div>
    <ng-template #logout let-modal>

      <div class="modal-successs">
        <!--<img class="sucesspopup" src="assets/img/badicon.gif" />-->

        <p class="textpopupsuccess">Are You Sure?</p>
        <p class="innerhtmlofmodal"> You Want To Logout?</p>
        <div class="marginbtnlft">
          <div>
            <button class="yesButton" (click)="yeslogout()">Yes, Logout!</button>
          </div>
          <div>
            <button class="noButton" (click)="modal.dismiss()">No</button>
          </div>
        </div>
      </div>


    </ng-template>
    <ng-template #updatePassword let-modal>
      <div class="modal-successs update-password-modal">
        <div class="modal-content-wrapper">
          <p class="textUpdatePassword">Update Password</p>
          <p class="updatePasswordhtmlofmodal">Please enter your current and new password below.</p>

          <div class="form-container">
            <div class="form-group">
              <label for="currentPassword">Current Password</label>
              <input type="password"
                id="currentPassword"
                [(ngModel)]="currentPassword"
                placeholder="Enter current password" />
              </div>

              <div class="form-group">
                <label for="newPassword">New Password</label>
                <input type="password"
                  id="newPassword"
                  [(ngModel)]="newPassword"
                  placeholder="Enter new password" />
                </div>
              </div>

              <div class="button-row">
                <!--<button class="yesButton small-btn" (click)="modal.close('update')">Update Password</button>-->
                <button class="yesButton small-btn" (click)="onUpdatePasswordClick(modal)">Update Password</button>
                <button class="noButton small-btn" (click)="modal.dismiss()">Cancel</button>
              </div>

            </div>
          </div>
        </ng-template>



        <div class="understand">
          <div class="credit-limit">
            <div class="credit-window">
              <!--<div class="f-dir">-->
              <!--<div style="position:relative;">
              <div style=" background-color: var(--first-color-second); color: #fff; font-size: 12px; padding: 4px 8px; border-radius: 15px;display:flex">
                <span class="badge credithover" (click)="GetLoginBackSystemCredit()">Credit Limit </span>
                <div class="loader-credit" *ngIf="creditLimitloader"></div>
              </div>
              <div *ngIf="creditLimitShow" style=" position: absolute;border-radius:5px; padding: 9px; box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; top: 22px; left: 0; background: white; z-index: 2;">
                <div style="width:100%;justify-content:end;align-items:end;display:flex;">
                  <span class="credithover" style="font-weight:bold;font-size:12px" (click)="closecreditlimit()"><i class="fas fa-close"></i></span>

                </div>
                <h6 style="color:black;margin-top:5px">Remaining Limit : {{backSystemCreditLimit.creditLimit}}</h6>
                <h6 style="color:black;margin-top:5px">Total Limit : {{backSystemCreditLimit.totalLimit}}</h6>
              </div>
            </div>-->
            <div class="credit-wrapper">
              <button class="credit-badge" (click)="GetLoginBackSystemCredit()">
                <span>Credit Limit</span>
                @if (creditLimitloader) {
                  <div class="loader-credit"></div>
                }
              </button>

              @if (creditLimitShow) {
                <div class="credit-popover">
                  <div class="popover-header">
                    <span class="close-icon" (click)="closecreditlimit()">
                      <i class="fas fa-close"></i>
                    </span>
                  </div>
                  <div class="popover-content">
                    <div class="credit-row">
                      <strong>Total Limit</strong>
                      <strong>{{ backSystemCreditLimit.totalLimit }}</strong>
                    </div>
                    <div class="credit-row">
                      <strong>Remaining Limit</strong>
                      <strong>{{ backSystemCreditLimit.creditLimit }}</strong>
                    </div>
                  </div>
                </div>
              }
            </div>

          <!--</div>-->
          <!--<div class="f-dir">-->
          <div class="agency-info-group">
            <h6 class="c-desc">Login Agency</h6>
            <h6 class="c-amount border-line">{{loginAgency }} - {{userName}}</h6>
          </div>
          <div class="manager-info-group">
            <h6 class="c-desc"><a class="manag" (click)="ManagerDetails(managerModel)">Manager</a></h6>
          </div>
          <div class="notification-container">
            <div class="notification-bell" (click)="toggleDropdown()">
              <i class="fas fa-bell" [class.shake]="isShaking"></i>
              <div class="notification-dot">
                @if (messages != null && messages != undefined) {
                  <p-badge value="{{messages.length}}" severity="info"></p-badge>
                }
              </div>
            </div>
            @if (isDropdownOpen) {
              <div class="notifications-dropdown">
                <div class="header">
                  <h3>Notifications</h3>
                  <span class="badge" (click)="mutechat()" style="cursor:pointer">{{mutestring}}</span>
                  @if (messages != null && messages != undefined) {
                    <span class="badge">{{ messages.length }} new</span>
                  }
                </div>
                @if (groupedMessages != null && groupedMessages != undefined) {
                  <div>
                    @for (uniqueId of objectKeys(groupedMessages); track uniqueId) {
                      <div>
                        @if (uniqueId !== '0' && uniqueId !== 0) {
                          <div class="booking-id-section">
                            <h4>
                              Booking ID:
                              <span class="booking-id">{{ uniqueId }}</span>
                            </h4>
                          </div>
                        }
                        <ul class="notification-list">
                          @for (message of groupedMessages[uniqueId]; track message) {
                            <li class="notification-item" (click)="messagetochat(uniqueId)">
                              <div class="text">
                                <div class="left">
                                  <h4>{{ message.senderName }}</h4>
                                  @if (!message.isImage &&!message.isFile  ) {
                                    <p>{{ message.content }}</p>
                                  }
                                  @if (message.isImage || message.isFile  ) {
                                    <p>Attachment</p>
                                  }
                                </div>
                                <div class="right">
                                  <span class="date">{{ message.date | date:'y MMM d'  }}</span>
                                  <span class="time">{{ message.timestamp }}</span>
                                </div>
                              </div>
                            </li>
                          }
                        </ul>
                      </div>
                    }
                  </div>
                }
                @if (noMessagefound) {
                  <div class="no-messages">
                    <div>
                      <p class="text">s=No messages</p>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          <!--<h6 class="c-amount border-line">{{loginAgency }}</h6>-->
        <!--</div>-->
        <!--<i class="fas fa-times" aria-hidden="true" style="font-size: 1.2rem" (click)="creditLimitClosed()"></i>-->
      </div>
    </div>
    <ul class="navbar-nav">
      <li class="nav-item"> <a class="nav-link" [routerLink]="['/flightSearch']">Home</a></li>
      @if (navMenue.adminPanelLogin) {
        <li class="nav-item dropdown">
          @if (navMenue.adminPanelLogin) {
            <a class="nav-link dropdown-toggle" data-toggle="dropdown">Admin</a>
          }
          <ul class="dropdown-menu">
            <li>
              @if (navMenue.accountManagement) {
                <a class="dropdown-item dropdown-toggle">Agency</a>
              }
              @if (navMenue.accountManagement) {
                <ul class="submenu dropdown-menu">
                  <li>@if (navMenue.accountManagement) {
                    <a class="dropdown-item" [routerLink]="['/agencyList']">Agency List</a>
                  }</li>
                </ul>
              }
            </li>
            @if (navMenue.revenueManagement) {
              <li><a class="dropdown-item" [routerLink]="['/revenueManagementList']">RevenueManagement</a></li>
            }
            <li>@if (navMenue.currency) {
              <a class="dropdown-item" [routerLink]="['/RateOfExchangeList']">Rate Of Exchange</a>
            }</li>
            <li>
              @if (navMenue.paymentProcess) {
                <a class="dropdown-item dropdown-toggle">Payment</a>
              }
              @if (navMenue.paymentProcess) {
                <ul class="submenu dropdown-menu">
                  <li>@if (navMenue.paymentList) {
                    <a class="dropdown-item" [routerLink]="['/paymentList']">Payment List</a>
                  }</li>
                  <li>@if (navMenue.paymentList) {
                    <a class="dropdown-item" [routerLink]="['/beneficaryDetails']">Beneficiary Details</a>
                  }
                  <li>
                    @if (navMenue.managerPaymentList) {
                      <a class="dropdown-item" [routerLink]="['/managerPaymentList']">
                        Manager Payment List
                      </a>
                    }
                  </li>
                </ul>
              }
            </li>
            <li>
              @if (navMenue.allocatedAccount) {
                <a class="dropdown-item dropdown-toggle">Beneficiary</a>
              }
              @if (navMenue.allocatedAccount) {
                <ul class="submenu dropdown-menu">
                  <li>@if (navMenue.beneficiaryAccount) {
                    <a class="dropdown-item" [routerLink]="['/beneficiary-account']">BeneficiaryAccount</a>
                  }</li>
                  <li><a class="dropdown-item" [routerLink]="['/allocateBeneficiaryAccount']">BeneficiaryAccount Allocation</a></li>
                </ul>
              }
            </li>
            <li>
              @if (navMenue.users) {
                <a class="dropdown-item" [routerLink]="['/userList']">Users</a>
              }
              <li>@if (navMenue.airline) {
                <a class="dropdown-item" [routerLink]="['/airline']">Airlines</a>
              }
              <li>@if (navMenue.importPnr) {
                <a class="dropdown-item" [routerLink]="['/importPNRList']">Import PNR List</a>
              }
              <li>
                @if (navMenue.paymentProcess) {
                  <a class="dropdown-item dropdown-toggle">Supplier</a>
                }
                @if (navMenue.supplierManagement) {
                  <ul class="submenu dropdown-menu">
                    <li>@if (navMenue.supplierManagement) {
                      <a class="dropdown-item" [routerLink]="['/suppliersList']">Suppliers List</a>
                    }</li>
                    <li> @if (navMenue.supplierManagement) {
                      <a class="dropdown-item" [routerLink]="['/offlineSupplierList']">Offline Supplier List</a>
                    }</li>
                    <li>@if (navMenue.supplierManagement) {
                      <a class="dropdown-item" [routerLink]="['/addSuppliers']">Suppliers Controls</a>
                    }
                    <li>@if (navMenue.supplierManagement) {
                      <a class="dropdown-item" [routerLink]="['/travelport-pcc-for-import-pnr']">TravelPort Agent Pccs</a>
                    }
                  </ul>
                }
              </li>
              <li>@if (navMenue.airport) {
                <a class="dropdown-item" [routerLink]="['/airport']">Airport</a>
              }
              <li>
                @if (navMenue.cms) {
                  <a class="dropdown-item" [routerLink]="['/cms']"> CMS</a>
                }
                <li>
                  @if (navMenue.cms) {
                    <a class="dropdown-item" [routerLink]="['/addManagers']">
                      Managers Controls
                    </a>
                  }
                </li>
                <li>
                  @if (navMenue.cms) {
                    <a class="dropdown-item" [routerLink]="['/importPnrEntry']">
                      Import PNR Entry
                    </a>
                  }
                </li>
                <li>
                  @if (navMenue.bookings) {
                    <a class="dropdown-item dropdown-toggle">My Booking</a>
                  }
                  @if (navMenue.bookings) {
                    <ul class="submenu dropdown-menu">
                      <li>
                        <a class="dropdown-item" [routerLink]="['/bookingList']">
                          Online Booking
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" [routerLink]="['/offline-my-booking-tkt-list']">
                          Offline Booking
                        </a>
                      </li>
                    </ul>
                  }
                </li>
                <li>
                  @if (navMenue.reportsManage) {
                    <a class="dropdown-item dropdown-toggle">Reports</a>
                  }
                  @if (navMenue.reportsManage) {
                    <ul class="submenu dropdown-menu">
                      @for (reportUser of reportRights; track reportUser; let i = $index) {
                        <li>
                          @if (reportUser.status) {
                            <a class="dropdown-item" [routerLink]="[reportUser.pageLink]">
                              {{reportUser.reportTypeName}}
                            </a>
                          }
                        </li>
                      }
                    </ul>
                  }
                </li>
                <li>
                  @if (navMenue.offlineRequest) {
                    <a class="dropdown-item dropdown-toggle">Offline Request</a>
                  }
                  @if (navMenue.offlineRequest) {
                    <ul class="submenu dropdown-menu">
                      <li>
                        @if (navMenue.offlineRequestList) {
                          <a class="dropdown-item" [routerLink]="['/offlineRequestList']">
                            Offline Request List
                          </a>
                        }
                      </li>
                      <li>
                        @if (navMenue.offlineManage) {
                          <a class="dropdown-item" [routerLink]="['/managerOfflineRequestList']">
                            Manager Offline List
                          </a>
                        }
                      </li>
                      <li>
                        @if (navMenue.managerOfflineRequestList) {
                          <a class="dropdown-item" [routerLink]="['/managerOnlineRequestList']">
                            Manager Online List
                          </a>
                        }
                      </li>
                    </ul>
                  }
                </li>
                <li>
                  @if (navMenue.companyMasterRight) {
                    <a class="dropdown-item" [routerLink]="['/companyMaster']">
                      Company Master
                    </a>
                  }
                </li>
                <li>
                  @if (navMenue.groupTicketCreateRight) {
                    <a class="dropdown-item dropdown-toggle">Group Ticket</a>
                  }
                  @if (navMenue.groupTicketCreateRight) {
                    <ul class="submenu dropdown-menu">
                      @if (navMenue.groupTicketCreateRight) {
                        <li><a class="dropdown-item" [routerLink]="['/addGroupTitle']">Add Group Title</a></li>
                      }
                      @if (navMenue.groupTicketCreateRight) {
                        <li><a class="dropdown-item" [routerLink]="['/groupTicket']">Add Group Ticket</a></li>
                      }
                    </ul>
                  }
                </li>
                <li>
                  @if (operatingCountry === 'Pakistan' ? navMenue.isRegisterBecomePartnerList : navMenue.cms) {
                    <a class="dropdown-item" [routerLink]="['/registerList']">Register List</a>
                  }
                </li>
                <li>
                  @if (loginAgency === 'AG01' && operatingCountry === 'Pakistan') {
                    <a class="dropdown-item" [routerLink]="['/umra-reservation-requests']">Umrah Reservation Requests</a>
                  }
                </li>
              </ul>
            </li>
          }
          <li class="nav-item"> <a class="nav-link" [routerLink]="['/zeusBookedPolicy']">Insurance</a></li>
          @if (operatingCountry === 'Pakistan') {
            <li class="nav-item"> <a class="nav-link" [routerLink]="['/umra-offers']">Umrah <span class="new-badge">New</span></a></li>
          }
          <li class="nav-item"> <a class="nav-link" [routerLink]="['/about-us']">About</a></li>
          <li class="nav-item"> <a class="nav-link" [routerLink]="['/contact-us']">Contact Us</a></li>
          <li class="nav-item"> <a class="nav-link" (click)="updatePasswordLinkClicked(updatePassword)">Update Password</a></li>
          <li class="nav-item"> <a class="nav-link" (click)="logoutlinkClicked(logout)">Log Out</a></li>
        </ul>
      </div>

    </div> <!-- navbar-collapse.// -->
  </nav>

  <!--<div class=" design-logout hidden-log">
  <h5 class="log-heading">Do you want to logout</h5>
  <div class="log-disp">
    <button class="log-btn" (click)="logoutClicked()">Log Out</button>
    <button class="log-btn" (click)="cancelClicked()">Cancel</button>
  </div>
</div>-->
<ng-template #managerModel let-modal>
  <div class="row m-0">
    <div class="col-md-10">
      <h2 class="textpopupemail">Manager Details</h2>
    </div>
    <div class="col-md-2">
      <span class="closepopupemail" (click)="modal.dismiss()">&times;</span>
    </div>


  </div>
  <div class="modal-success ">

    <i class="fas fa-times cross-pos" aria-hidden="true" style="font-size: 1.2rem" (click)="ManagerClosed()"></i>
    <div class="manager-details">
      <div class="m-align">
        <h6 class="m-desc">Manager Name:</h6>
        <h6 class="m-det">{{managerDetails?.managerName}}</h6>
      </div>
      <div class="m-align">
        <h6 class="m-desc">Contact No:</h6>
        <h6 class="m-det">{{managerDetails?.managerPhone}}</h6>
      </div>
      <div class="m-align">
        <h6 class="m-desc">Email Address:</h6>
        <h6 class="m-det">{{managerDetails?.managerEmailAddress}}</h6>
      </div>
    </div>


  </div>
</ng-template>
<!--<div class="manager-window manager-hidden">
<i class="fas fa-times cross-pos" aria-hidden="true" style="font-size: 1.2rem" (click)="ManagerClosed()"></i>
<div class="manager-details">
  <div class="m-align">
    <h6 class="m-desc">Manager Name:</h6>
    <h6 class="m-det">{{managerDetails?.managerName}}</h6>
  </div>
  <div class="m-align">
    <h6 class="m-desc">Contact No:</h6>
    <h6 class="m-det">{{managerDetails?.managerPhone}}</h6>
  </div>
  <div class="m-align">
    <h6 class="m-desc">Email Address:</h6>
    <h6 class="m-det">{{managerDetails?.managerEmailAddress}}</h6>
  </div>
</div>

</div>-->



<!--<header class="header" id="header">
<nav class="navbar navbar-expand-lg container">
  <a href="" class="nav__logo"><img src="" alt=""></a>
  <div class="collapse navbar-collapse" id="navbarContent">
    <ul class="navbar-nav ml-auto">
      <li class="nav-item">
        <a class="nav-link active nav_color" href="#">Home</a>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link nav_color dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false">Admin</a>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item nav-link" [routerLink]="['/agencyList']">Agency</a></li>
          <li><a class="dropdown-item nav-link" [routerLink]="['/branchList']">Branch</a></li>
          <li><a class="dropdown-item nav-link" [routerLink]="['/userList']">Users</a></li>
          <li><a class="dropdown-item nav-link" [routerLink]="['/suppliersList']">Suppliers</a></li>
          <li><a class="dropdown-item nav-link" [routerLink]="['/agencyBranchChart']">AgencyBranch</a></li>
          <li><a class="dropdown-item nav-link" [routerLink]="['/cms']">CMS</a></li>
          <li><a class="dropdown-item nav-link" [routerLink]="['/revenueManagementList']">RevenueManagement</a></li>
          <li><a class="dropdown-item nav-link" [routerLink]="['/agencySupplierRights']">Agency Supplier Rights</a></li>
          <li><a class="dropdown-item nav-link" [routerLink]="['/beneficiary-account']">BeneficiaryAccount</a></li>
          <li><a class="dropdown-item nav-link" [routerLink]="['/allocateBeneficiaryAccount']">BeneficiaryAccount Allocation</a></li>
          <li><a class="dropdown-item nav-link" [routerLink]="['/agency_BranchGroupList']">Agency Groups</a></li>
          <li><a class="dropdown-item nav-link" [routerLink]="['/flightSearch']">Flight Search </a></li>
          <li><a class="dropdown-item nav-link" [routerLink]="['/paymentList']">Payment List</a></li>
          <li><a class="dropdown-item nav-link" [routerLink]="['/managerPaymentList']">Manager Payment List</a></li>
          <li><a class="dropdown-item nav-link" [routerLink]="['/flightResults']">Flight Results</a></li>
          <li><a class="nav__item" [routerLink]="['/managerOfflineRequestList']">Manager Offline List</a></li>
          <li><a class="nav__item" [routerLink]="['/offlineRequestList']">Offline Request List</a></li>
          <li>
            <a class="nav__item" [routerLink]="['/offlineRequestAddEdit']">Add/Edit Offline Request</a>
          </li>
        </ul>
      </li>
      <li class="nav-item">
        <a class="nav-link nav_color">about</a>
      </li>
      <li class="nav-item">
        <a class="nav-link nav_color">Contact Us</a>
      </li>
    </ul>
  </div>
  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="uil uil-apps"></span>
  </button>
</nav>
</header>-->
<!--<header class="header" id="header">
<nav class="nav container">
  <a href="" class="nav__logo"><img src="" alt=""></a>
  <div class="nav__menu" id="nav-menu">
    <ul class="nav__list">
      <li class="nav__item">
        <a href="#home" class="nav__link">Home</a>
      </li>
      <li class="nav__item">
        <a href="#about" class="nav__link">About</a>
      </li>
      <li class="nav__item">
        <a href="#services" class="nav__link">Services</a>
      </li>
      <li class="nav__item">
        <a href="#contact" class="nav__link">Contact</a>
      </li>
    </ul>
    <i class="uit uil-times nav__close" id="nav-close"></i>
  </div>

  <div class="nav__toggle" id="nav-toggle">
    <i class="uil uil-apps"></i>
  </div>
</nav>
</header>-->
